import { allEnumValues, CustomerAccountsUsage, UserRight } from '@biteinc/enums';
export const flashSettingsSchema = {
    // Location Model Settings
    // FLASH SETTINGS
    flashShowPageNavigation: {
        displayName: 'Show Page Navigation',
        type: 'bool',
        required: true,
        tabId: 'flash-settings-v2',
        biteOnly: true,
        tooltip: {
            text: 'Show a page navigation screen upon entering the menu. Requires design customization before use.',
        },
    },
    showClosedScreen: {
        displayName: 'Show Closed Screen',
        type: 'bool',
        required: true,
        tabId: 'flash-settings-v2',
        tooltip: {
            text: 'Displays an undismissable closed screen when Flash launches.',
        },
        writeRight: UserRight.ShowFlashClosedScreen,
    },
    thirdPartyAnalyticsId: {
        displayName: '3rd-Party Analytics ID',
        type: 'keyString',
        tabId: 'flash-settings-v2',
        validationRegex: '^UA-[0-9]+-[0-9]$',
        tooltip: {
            text: 'Google Analytics only for now.',
        },
        writeRight: UserRight.ManageChannelSettings,
    },
    customerAccountsUsage: {
        displayName: 'Customer Accounts Usage',
        type: 'int',
        values: allEnumValues(CustomerAccountsUsage),
        required: true,
        tabId: 'flash-settings-v2',
        writeRight: UserRight.ManageChannelSettings,
        ui: 'dropdown',
    },
    cartDisclaimer: {
        displayName: 'Cart Disclaimer',
        type: 'shortString',
        tabId: 'flash-settings-v2',
        writeRight: UserRight.ManageChannelSettings,
        tooltip: {
            text: 'Show up above total in cart',
        },
    },
    checkoutDisclaimer: {
        displayName: 'Checkout Disclaimer',
        type: 'shortString',
        tabId: 'flash-settings-v2',
        writeRight: UserRight.ManageChannelSettings,
        tooltip: {
            text: 'Only shows up in Checkout V2',
        },
    },
    askToIncludeUtensilsOnFlashOrders: {
        displayName: 'Utensils opt in on Flash orders',
        type: 'bool',
        required: true,
        tabId: 'flash-settings-v2',
        tooltip: {
            text: 'If set it will send "include Utensils" to the POS',
        },
    },
};
//# sourceMappingURL=settings_flash_schema.js.map